import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';
import s from 'components/bolt/ticketAreaButton/ticketAreaButton.sss';


export default class TicketAreaButton extends Component {

	render({ text, onClick, disabled, children }) {
		return (
			<button class={joinClasses(s.btn, disabled && s.disabled)} onClick={onClick} disabled={disabled}>
				{text}
				{children}
			</button>
		);
	}
}